import React, { useEffect, useState } from 'react';
import axios from 'axios';


function ChildSafetyPolicy() {
  const [chPolicy, setCHPolicy] = useState('')

  useEffect(() => {
      const getEula = async () => {
        const resp = await axios.get(process.env.REACT_APP_API_URL + 'childSafetyPolicy')
        setCHPolicy(resp?.data?.childSafetyPolicy ? resp.data.childSafetyPolicy : '')
      }

      getEula()
  }, [])

  return (
    <div className="doc">
      <div style={{ whiteSpace: 'pre-wrap' }}>
        {chPolicy}
      </div>
    </div>
  );
}

export default ChildSafetyPolicy
